import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStatusPill } from 'types/ui/statusPill.interface'

export const LevelBlock = styled.div`
  display: flex;
  flex-direction: column;
`

export const LevelBarRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
`

export const LevelTrack = styled.div`
  position: relative;
  width: 2.25rem;
  height: 5.5rem;
  flex-shrink: 0;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  overflow: hidden;
`

export const TrackColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
`

export const DualTrack = styled.div`
  position: relative;
  display: flex;
  gap: 2px;
  width: calc(2rem + 2px);
  height: 5.5rem;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  overflow: hidden;
`

export const DualTrackHalf = styled.div`
  position: relative;
  flex: 1 1 0;
  height: 100%;
`

export const TrackLegend = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
  white-space: nowrap;
`

export const LevelTick = styled.div<{ $at: number }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${({ $at }) => $at}%;
  height: 1px;
  background: ${tokens.border.hairline};
  z-index: 1;
`

export const LevelFill = styled.div<{ $pct: number; $tone: IStatusPill['status'] }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${({ $pct }) => Math.min($pct, 100)}%;
  background: ${({ $tone }) => tokens.status[$tone].fg};
  transition: height 0.4s ease;
`

export const LevelText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const LevelPct = styled.span`
  font-size: ${tokens.font.display};
  font-weight: 500;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const LevelLitres = styled.span`
  margin-top: 0.25rem;
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`

export const SensorDeltaNote = styled.span`
  margin-top: 0.25rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.status.warning.fg};
  line-height: 1.4;
`
